import React from "react"
import { Form, Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import SiteSurveysGearBoxesFormPiece from "./SiteSurveysGearBoxesFormPiece"

function SiteSurveysGearBoxesForm(props) {
    /////*** event handler methods start ***/////
    const handleRemove = (field, remove) => {
        let allValues = props.form.getFieldValue()

        if (!!allValues.gear_boxes_attributes[field.name]) {
            if (!!allValues.gear_boxes_attributes[field.name]["site_survey_id"]) {
                let updatedFieldsToRemove = [...props.toRemove]
                updatedFieldsToRemove.push({ ...allValues.gear_boxes_attributes[field.name], _destroy: true })
                props.setToRemove(updatedFieldsToRemove)
            }
        }
        remove(field.name)
    }
    /////*** event handler methods end ***/////

    return (
        <div id={"site-surveys-gear-boxes-form"} className={"card"}>
            <Form.List name={"gear_boxes_attributes"}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field) => (
                            <SiteSurveysGearBoxesFormPiece {...field} key={field.key} remove={() => handleRemove(field, remove)} />
                        ))}
                        <Form.Item className={"add-field"}>
                            <Button block onClick={() => add()} icon={<PlusOutlined />}>
                                Add field
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>
    )
}

export default SiteSurveysGearBoxesForm
